import { useSelector } from 'react-redux'

// The home's configured nominative for the people it supports (e.g. "resident",
// "client"). Falls back to "service user" when unset.
export const useServiceUserNominative = (): string =>
  useSelector(
    (s: { global: { home: { preferredPeopleNominative?: string } } }) =>
      s.global.home?.preferredPeopleNominative ?? 'service user'
  )
